import { useEffect } from 'react';
import { useNotifications } from '@/providers/notificationHooks';
import { useMutationError } from './useMutationError';

export const useMutationErrorSnackbar = (): ReturnType<typeof useMutationError> => {
  const mutationError = useMutationError();
  const { notify } = useNotifications();

  useEffect(() => {
    if (!mutationError.error) return;
    notify({ message: mutationError.error, tone: 'red' });
  }, [mutationError.error, mutationError.errorNonce, notify]);

  return mutationError;
};
